var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"breadcrumbList__item"},[_c('v-icon',{staticClass:"breadcrumbList__icon"},[_vm._v("chevron_right")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }